import { dynamicTabsReqs } from '../dynamicTabsByProduct';
import {
  ReadProfileResponse,
  ReadProfileResponseData,
  ReadProfileResponseSuccessData,
  RouterNextState,
  TabReq,
} from '../types';

function isInvoiceManagementRoleAuthorized(data: ReadProfileResponseData, tabReq: TabReq) {
  if (
    'invoiceManagementRole' in data &&
    typeof data.invoiceManagementRole === 'string' &&
    tabReq.invoiceManagementRole
  ) {
    return tabReq.invoiceManagementRole.includes(data.invoiceManagementRole);
  }
  return false;
}

function isProductTypesAuthorized(data: ReadProfileResponseSuccessData, tabReq: TabReq) {
  return (
    data.productTypes &&
    data.productTypes.some((productType) => tabReq.productTypes.includes(productType))
  );
}

function isRoleAuthorized(data: ReadProfileResponseData, tabReq: TabReq) {
  if (!tabReq.role) {
    return false;
  }
  if ('role' in data) {
    return tabReq.role.includes(data.role);
  }
  return tabReq.role.includes('ADMIN') && tabReq.role.includes('BASIC');
}

export const isAuthorizedForRoute = (nextState: RouterNextState, response: ReadProfileResponse) => {
  const foundTab = Object.keys(dynamicTabsReqs).find((dynamicTab) =>
    nextState.location.pathname.startsWith(
      `/en-us/business/payment-solutions/supplier-dashboard/${dynamicTab}`
    )
  );
  if (!foundTab) {
    return true;
  }
  const tabKey = foundTab as keyof typeof dynamicTabsReqs;
  const tabReq: TabReq = dynamicTabsReqs[tabKey];
  if ('productTypes' in response.data && !isProductTypesAuthorized(response.data, tabReq)) {
    return false;
  }
  if (
    tabReq.productTypes.includes('INVOICE_MANAGEMENT') &&
    isInvoiceManagementRoleAuthorized(response.data, tabReq)
  ) {
    return true;
  }
  return isRoleAuthorized(response.data, tabReq);
};
